import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Client } from "./API/client";
import { toastrService } from "./ux/toastr.service";

export interface Deposit {
  depositNumber: number;
  depositReference: string;
  productCode: string;
  startDate: any;
  interestRateCondition: string;
  daysUntilRollover: number;
  accountType: string;
  accountStatus: boolean; 
  maturityInstruction: string;
  interestRate: number;
  maturityDate: any;
  sourceAccount: string;
  paybackAccount: string;
  interestPaybackAccount: string;
  originalAmount: number;
  maturityAmount: number;
  interestAmountAtMaturity: number;
  annualEquivalentRate: number;
  currentBalance: number;
  interestDescription: string;
}

@Injectable()
export class DepositService {
  private depositSource = new BehaviorSubject<Deposit[]>([]);
  deposits = this.depositSource.asObservable();

  constructor(private api: Client, private toastr: toastrService) {}

  public async getDeposits() {
    try {
      const data = await this.api.get("api/deposit/deposits")
      this.depositSource.next(data as Deposit[])
    } catch(err) {
      this.toastr.error(err.error)
    }
  }
}
